var _circle, _mask, _g, _mask2, _g2, _mask3, _g3, _mask4, _g4, _mask5, _g5, _mask6, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanetJupiter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 582,
    height: 582,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 291,
    r: 291,
    fill: "#ECAD7A"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 582,
    height: 582
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 291,
    r: 291,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 294c6.627 0 12 5.373 12 12s-5.373 12-12 12h-156c-6.627 0-12-5.373-12-12s5.373-12 12-12H38zm220 0c6.627 0 12 5.373 12 12s-5.373 12-12 12h-78v.01c-6.395.262-11.5 5.53-11.5 11.99s5.105 11.728 11.5 11.99v.01h160c6.627 0 12 5.373 12 12s-5.373 12-12 12H83c-6.627 0-12-5.373-12-12s5.373-12 12-12h49c6.627 0 12-5.373 12-12s-5.373-12-12-12h-30c-6.627 0-12-5.373-12-12s5.373-12 12-12h156zM53 390c6.627 0 12 5.373 12 12s-5.373 12-12 12h-73c-6.627 0-12-5.373-12-12s5.373-12 12-12h73zm287 0c6.627 0 12 5.373 12 12s-5.373 12-12 12h-73c-6.627 0-12-5.373-12-12s5.373-12 12-12h73zm264 12c0-6.627-5.373-12-12-12H426c-6.627 0-12 5.373-12 12s5.373 12 12 12h166c6.627 0 12-5.373 12-12zm-190-84c6.627 0 12 5.373 12 12s-5.373 12-12 12h-9c-6.627 0-12 5.373-12 12s5.373 12 12 12h257c6.627 0 12-5.373 12-12s-5.373-12-12-12H462v-.01c-6.395-.262-11.5-5.53-11.5-11.99s5.105-11.728 11.5-11.99V318h24c6.627 0 12-5.373 12-12s-5.373-12-12-12H330c-6.627 0-12 5.373-12 12s5.373 12 12 12h84zm298-12c0-6.627-5.373-12-12-12H544c-6.627 0-12 5.373-12 12s5.373 12 12 12h156c6.627 0 12-5.373 12-12z",
    fill: "#F0D29F"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 582,
    height: 582
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 291,
    r: 291,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159 402c0-6.627-5.373-12-12-12h-29c-6.627 0-12-5.373-12-12s5.373-12 12-12h101c6.627 0 12 5.373 12 12s-5.373 12-12 12h-3l-.001.01c-6.395.263-11.499 5.53-11.499 11.99s5.104 11.727 11.499 11.99l.001.01h3c6.627 0 12 5.373 12 12s-5.373 12-12 12h-76c-6.627 0-12-5.373-12-12s5.373-12 12-12h4c6.627 0 12-5.373 12-12z",
    fill: "#D86534"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 582,
    height: 582
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 291,
    r: 291,
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M466 54c-6.627 0-12 5.373-12 12s5.373 12 12 12h156c6.627 0 12-5.373 12-12s-5.373-12-12-12H466zm-220 0c-6.627 0-12 5.373-12 12s5.373 12 12 12h78v.01c6.395.262 11.5 5.53 11.5 11.99s-5.105 11.728-11.5 11.99v.01H164c-6.627 0-12 5.373-12 12s5.373 12 12 12h257c6.627 0 12-5.373 12-12s-5.373-12-12-12h-49c-6.627 0-12-5.373-12-12s5.373-12 12-12h30c6.627 0 12-5.373 12-12s-5.373-12-12-12H246zm205 96c-6.627 0-12 5.373-12 12s5.373 12 12 12h73c6.627 0 12-5.373 12-12s-5.373-12-12-12h-73zm-287 0c-6.627 0-12 5.373-12 12s5.373 12 12 12h73c6.627 0 12-5.373 12-12s-5.373-12-12-12h-73zm-264 12c0-6.627 5.373-12 12-12H78c6.627 0 12 5.373 12 12s-5.373 12-12 12H-88c-6.627 0-12-5.373-12-12zM90 78c-6.627 0-12 5.373-12 12s5.373 12 12 12h9c6.627 0 12 5.373 12 12s-5.373 12-12 12h-257c-6.627 0-12-5.373-12-12s5.373-12 12-12H42v-.01c6.395-.262 11.5-5.53 11.5-11.99S48.395 78.272 42 78.01V78H18c-6.627 0-12-5.373-12-12s5.373-12 12-12h156c6.627 0 12 5.373 12 12s-5.373 12-12 12H90zm-298-12c0-6.627 5.373-12 12-12h156c6.627 0 12 5.373 12 12s-5.373 12-12 12h-156c-6.627 0-12-5.373-12-12z",
    fill: "#DC8E61"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 582,
    height: 582
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 291,
    r: 291,
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624 438c-6.627 0-12 5.373-12 12s5.373 12 12 12h156c6.627 0 12-5.373 12-12s-5.373-12-12-12H624zm-220 0c-6.627 0-12 5.373-12 12s5.373 12 12 12h78v.01c6.395.262 11.5 5.53 11.5 11.99s-5.105 11.728-11.5 11.99v.01H322c-6.627 0-12 5.373-12 12s5.373 12 12 12h257c6.627 0 12-5.373 12-12s-5.373-12-12-12h-49c-6.627 0-12-5.373-12-12s5.373-12 12-12h30c6.627 0 12-5.373 12-12s-5.373-12-12-12H404zm205 96c-6.627 0-12 5.373-12 12s5.373 12 12 12h73c6.627 0 12-5.373 12-12s-5.373-12-12-12h-73zm-287 0c-6.627 0-12 5.373-12 12s5.373 12 12 12h73c6.627 0 12-5.373 12-12s-5.373-12-12-12h-73zM58 546c0-6.627 5.373-12 12-12h166c6.627 0 12 5.373 12 12s-5.373 12-12 12H70c-6.627 0-12-5.373-12-12zm190-84c-6.627 0-12 5.373-12 12s5.373 12 12 12h9c6.627 0 12 5.373 12 12s-5.373 12-12 12H0c-6.627 0-12-5.373-12-12s5.373-12 12-12h200v-.01c6.395-.262 11.5-5.53 11.5-11.99s-5.105-11.728-11.5-11.99V462h-24c-6.627 0-12-5.373-12-12s5.373-12 12-12h156c6.627 0 12 5.373 12 12s-5.373 12-12 12h-84zm-298-12c0-6.627 5.373-12 12-12h156c6.627 0 12 5.373 12 12s-5.373 12-12 12H-38c-6.627 0-12-5.373-12-12z",
    fill: "#D89D6D"
  }))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "e",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 582,
    height: 582
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 291,
    r: 291,
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177 222c6.627 0 12 5.373 12 12s-5.373 12-12 12h-10c-6.627 0-12 5.373-12 12s5.373 12 12 12h89c6.627 0 12-5.373 12-12s-5.373-12-12-12h-10l-.001-.01c-6.395-.263-11.499-5.53-11.499-11.99s5.104-11.727 11.499-11.99L246 222h65c6.627 0 12-5.373 12-12s-5.373-12-12-12H112c-6.627 0-12 5.373-12 12s5.373 12 12 12h65zm-46 36c0-6.627-5.373-12-12-12H57c-6.627 0-12 5.373-12 12s5.373 12 12 12h62c6.627 0 12-5.373 12-12zM9 246c6.627 0 12 5.373 12 12s-5.373 12-12 12h-28c-6.627 0-12-5.373-12-12s5.373-12 12-12H9zm475 12c0-6.627-5.373-12-12-12H304c-6.627 0-12 5.373-12 12s5.373 12 12 12h168c6.627 0 12-5.373 12-12zm64-12c6.627 0 12 5.373 12 12s-5.373 12-12 12h-28c-6.627 0-12-5.373-12-12s5.373-12 12-12h28zm-35-36c0-6.627-5.373-12-12-12H359c-6.627 0-12 5.373-12 12s5.373 12 12 12h142c6.627 0 12-5.373 12-12zm86-12c6.627 0 12 5.373 12 12s-5.373 12-12 12h-50c-6.627 0-12-5.373-12-12s5.373-12 12-12h50zM52 210c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12s5.373 12 12 12h28c6.627 0 12-5.373 12-12z",
    fill: "#D89D6D"
  }))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "f",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 582,
    height: 582
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 291,
    r: 291,
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.078,
    fill: "#000",
    d: "M291 0h292v582H291z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetJupiter);
export default __webpack_public_path__ + "static/media/planet-jupiter.b1d0956b70a8ccb39f171a258ccd98fd.svg";
export { ForwardRef as ReactComponent };